import React, {useMemo} from "react";
import {Box, MenuItem, TextField, Typography} from "@mui/material";
import {CalendarDays} from "lucide-react";

const MONTH_OPTIONS = [
    {value: '01', label: 'Janeiro'},
    {value: '02', label: 'Fevereiro'},
    {value: '03', label: 'Março'},
    {value: '04', label: 'Abril'},
    {value: '05', label: 'Maio'},
    {value: '06', label: 'Junho'},
    {value: '07', label: 'Julho'},
    {value: '08', label: 'Agosto'},
    {value: '09', label: 'Setembro'},
    {value: '10', label: 'Outubro'},
    {value: '11', label: 'Novembro'},
    {value: '12', label: 'Dezembro'},
];

export default function CompetenciaField({
    label = 'Competência (Mês/Ano)',
    required = false,
    month = '',
    year = '',
    onMonthChange,
    onYearChange,
    error = false,
    helperText = '',
    minYear,
    maxYear,
    years,
}) {
    const yearOptions = useMemo(() => {
        if (Array.isArray(years) && years.length) return years.map((value) => `${value}`);

        const currentYear = new Date().getFullYear();
        const startYear = Number.isInteger(minYear) ? minYear : currentYear - 3;
        const endYear = Number.isInteger(maxYear) ? maxYear : currentYear + 3;
        const total = Math.max(endYear - startYear + 1, 1);

        return Array.from({length: total}, (_, index) => `${startYear + index}`);
    }, [maxYear, minYear, years]);

    return (
        <Box>
            <Typography variant="body2" sx={{color: '#374151', mb: 1}}>
                {label} {required ? <Box component="span" sx={{color: '#ef4444'}}>*</Box> : null}
            </Typography>

            <Box sx={{display: 'grid', gridTemplateColumns: {xs: '1fr', sm: '1.4fr 1fr'}, gap: 1.5}}>
                <TextField
                    select
                    value={month}
                    onChange={(event) => onMonthChange?.(event.target.value)}
                    error={Boolean(error)}
                    fullWidth
                    InputProps={{
                        startAdornment: (
                            <Box sx={{display: 'flex', alignItems: 'center', color: '#9ca3af', mr: 1}}>
                                <CalendarDays size={18} />
                            </Box>
                        ),
                    }}
                >
                    <MenuItem value="">Selecione o mês</MenuItem>
                    {MONTH_OPTIONS.map((item) => (
                        <MenuItem key={item.value} value={item.value}>
                            {item.label}
                        </MenuItem>
                    ))}
                </TextField>

                <TextField
                    select
                    value={year}
                    onChange={(event) => onYearChange?.(event.target.value)}
                    fullWidth
                >
                    {yearOptions.map((item) => (
                        <MenuItem key={item} value={item}>
                            {item}
                        </MenuItem>
                    ))}
                </TextField>
            </Box>

            <Typography variant="caption" sx={{display: 'block', mt: 1, color: error ? '#d32f2f' : '#6b7280'}}>
                {helperText}
            </Typography>
        </Box>
    );
}
